// Metric Unit Function to find BMI to check if height and weight are acceptable
// (BMI should be in the range 10-65)
export const calculateBMIMetricUnit = (weightInKg, heightInCm) => {
  const heightInMeters = parseInt(heightInCm) / 100;
  const bmi = parseInt(weightInKg) / (heightInMeters * heightInMeters);
  return bmi;
};
